import {
    ShoppingBag,
    Clock3,
    ChefHat,
    PackageCheck,
    Bike,
    CheckCircle2,
    XCircle,
    IndianRupee,
    TrendingUp,
} from "lucide-react";

import "./OrderStats.css";

function OrderStats({ stats }) {

    const cards = [

        {
            title: "Total Orders",
            value: stats.total,
            icon: <ShoppingBag size={24} />,
            className: "blue",
        },

        {
            title: "Pending",
            value: stats.pending,
            icon: <Clock3 size={24} />,
            className: "orange",
        },

        {
            title: "Preparing",
            value: stats.preparing,
            icon: <ChefHat size={24} />,
            className: "purple",
        },

        {
            title: "Ready",
            value: stats.ready,
            icon: <PackageCheck size={24} />,
            className: "cyan",
        },

        {
            title: "Out For Delivery",
            value: stats.outForDelivery,
            icon: <Bike size={24} />,
            className: "sky",
        },

        {
            title: "Delivered",
            value: stats.delivered,
            icon: <CheckCircle2 size={24} />,
            className: "green",
        },

        {
            title: "Cancelled",
            value: stats.cancelled,
            icon: <XCircle size={24} />,
            className: "red",
        },

        {
            title: "Revenue",
            value: `₹${Number(stats.revenue || 0).toLocaleString("en-IN")}`,
            icon: <IndianRupee size={24} />,
            className: "maroon",
        },

    ];

    return (

        <div className="order-stats-grid">

            {cards.map((card, index) => (

                <div
                    key={index}
                    className={`order-stat-card ${card.className}`}
                >

                    <div className="order-stat-top">

                        <div className="order-stat-icon">

                            {card.icon}

                        </div>

                        <div className="order-trend">

                            <TrendingUp size={15} />

                        </div>

                    </div>

                    <div className="order-stat-content">

                        <p>

                            {card.title}

                        </p>

                        <h2>

                            {card.value}

                        </h2>

                    </div>

                </div>

            ))}

        </div>

    );

}

export default OrderStats;